import Component from "../../lib/component";
import {InventoryFilter, InventoryFilterConfig} from "./inventory_filter";
import {InventoryItem} from "./inventory_item";
import {InventoryHead, InventoryHeadConfig} from "./inventory_head";

export const InventoryConfig = {
    componentTypeKey: 'Inventory',
    baseHtmlClass: 'inventory',
    selector: '.inventory',

    datasetConfigKey: 'inventory__config',
    willFilterDatasetConfigKey: 'will_filter',
    filterThresholdDatasetConfigKey: 'filter_threshold',
    filterPlaceholderDatasetConfigKey: 'filter_placeholder',

    defaultWillFilter: false,
    defaultFilterThreshold: 10,

    itemsSelector: '.inventory__table > tbody > tr',
};

export class Inventory extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: InventoryConfig
        });

        this.setDatasetConfig(InventoryConfig.datasetConfigKey);
        this.filterThreshold = this.getFilterThresholdConfig();
        this.willFilter = this.getWillFilterConfig();
        this.filterPlaceholder = this.getFilterPlaceholderConfig();

        const itemElements = this.element.querySelectorAll(InventoryConfig.itemsSelector);
        this.items = [];
        if (itemElements) {
            this.items = [...itemElements].map((element) => {
                return new InventoryItem(element, this);
            });
        }

        this.head = this.createHead();
        this.filter = this.createFilter();

        this.render();
    }

    render() {
        this.swapHtmlClassStates(this.getWillFilter(), 'will_filter', 'no_filter');

        this.items.forEach((item) => {
            if (item) item.render();
        });
    }

    createFilter() {
        const filterElement = InventoryFilter.createElement(this);
        this.head.element.append(filterElement);
        return new InventoryFilter(filterElement, this);
    }

    createHead() {
        // The head element may already exist in the DOM.
        let headElement = this.element.querySelector(InventoryHeadConfig.selector);
        if (!headElement) {
            // Otherwise we'll create and insert it.
            headElement = InventoryHead.createElement();
            this.element.insertBefore(headElement, this.element.firstChild);
        }
        return new InventoryHead(headElement, this);
    }

    getWillFilterConfig() {
        const configValue = this.getDatasetConfigValue(InventoryConfig.willFilterDatasetConfigKey);
        return ((typeof configValue !== 'undefined') ? configValue : InventoryConfig.defaultWillFilter);
    }

    getFilterThresholdConfig() {
        const configValue = this.getDatasetConfigValue(InventoryConfig.filterThresholdDatasetConfigKey);
        return ((typeof configValue !== 'undefined') ? configValue : InventoryConfig.defaultFilterThreshold);
    }

    getFilterPlaceholderConfig() {
        const configValue = this.getDatasetConfigValue(InventoryConfig.filterPlaceholderDatasetConfigKey);
        return ((typeof configValue !== 'undefined') ? configValue : InventoryFilterConfig.defaultPlaceHolder);
    }

    // Will the filter be shown?
    getWillFilter() {
        if (this.willFilter) return true; // Yes, when willFilter is was explicitly set to true.
        if (this.items.length < this.filterThreshold) return false; // No, when items count is less than the threshold.
        return this.willFilter;
    }
}
